import api from '@/services/index.js'
async function fetchBonus(callback) {
  await api
    .get('/user-profile-composite/v1/info/promotion')
    .then((v) => {
      callback({ status: true, data: v.data, message: v.message })
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.status.message })
    })
    .finally(() => {})
}
async function updateBonus(swal, isBonus, callback) {
  var cacheBonus = isBonus
  swal
    .fire({
      title: `คุณต้องการเปลี่ยนสถานะเป็น ${
        cacheBonus == false ? 'ไม่รับโปรโมชั่น' : 'รับโปรโมชั่น'
      } ใช่หรือไม่`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      denyButtonText: `ไม่ใช่`,
      cancelButtonText: `ไม่ใช่`,
    })
    .then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        await api
          .post('/user-profile-composite/v1/users/setting', {
            isBonus: cacheBonus,
          })
          .then(async (v) => {
            callback({
              status: true,
              data: !cacheBonus,
              message: 'อัพเดทสภานะโปรโมชั่นเรียบร้อยแล้ว',
            })
          })
          .catch((e) => {
            callback({
              status: false,
              data: isBonus,
              message: e.status.message,
            })
          })
          .finally(() => {
            callback({
              status: false,
              data: isBonus,
              message: '',
            })
          })
      } else {
        callback({ status: false, data: isBonus, message: '' })
      }
    })
}
export { fetchBonus, updateBonus }



// WEBPACK FOOTER //
// ./src/services/modules/promotion.js